export default "__VITE_ASSET__B_PIb88L__"